// DOM Content Loaded
document.addEventListener("DOMContentLoaded", function () {

    // Select all play buttons with data-video attribute
    const videoPlayTriggers = document.querySelectorAll('.js-video-play');

    for (const videoPlayTrigger of videoPlayTriggers) {
        videoPlayTrigger.addEventListener('click', () => {
            const videoPlayTriggerId = videoPlayTrigger.getAttribute('data-video');
            const videoTarget = document.getElementById(videoPlayTriggerId);

            if (videoTarget) {
                // Hide the custom play button
                videoPlayTrigger.style.display = 'none';

                // Play the video
                videoTarget.play();

                // Show native controls after starting
                videoTarget.setAttribute('controls', 'true');
            }
        });
    }

});
